import {
  AdCampaignModuleType,
  DisplayAdEventContent,
  DisplayAdVariantPackFieldsFragment,
  ItemsContext_VariantsPackFieldsFragment,
  SampleRequestVariantPackFieldsFragment,
} from '@/types';

export interface DisplayAdModule {
  adManagerUUID: string;
  advertiserUUID: string;
  campaignUUID: string;
  content: DisplayAdEventContent;
  variantPackEventMap: DisplayAdVPEventMap;
  variantPacks: ItemsContext_VariantsPackFieldsFragment[];
}

export enum AdModuleType {
  DisplayAd = 'DISPLAY_AD',
  PaidSearch = 'PAID_SEARCH',
  SampleRequest = 'SAMPLE_REQUEST',
}

export enum AdImpressionSource {
  Catalog = 'CATALOG',
  OrderGuide = 'ORDER_GUIDE',
  Search = 'SEARCH',
}

export interface AdEventData {
  adManagerUUID: string;
  adModule: AdCampaignModuleType;
  advertiserUUID: string;
  eventUUID: string;
  gtin: string;
  keyword?: string;
  source: string;
}

export interface ImpressionEvent {
  adEventData: AdEventData;
  campaignUUID: string;
  impressionSource: AdImpressionSource;
  impressionURL?: string;
  type: AdModuleType;
  variantPackUUID: string;
}

export type SampleRequestMap = Partial<
  Record<string, SampleRequestVariantPackFieldsFragment>
>;
export type DisplayAdVPEventMap = Partial<
  Record<string, DisplayAdVariantPackFieldsFragment>
>;
